export default __webpack_public_path__ + "static/stargazer_bg-afc8253827e6124746b76ca18204f499.png";